import { Adapter } from './adapter';
import { EnrolledSessions } from '../models/enrolled-sessions.model';
import { EnrolledSessionsInterface } from '@app/interfaces/_index';

/**
 * Adapt raw service Docebo enrolled session object to Enrolled Sessions model
 * NOTE: The item fields are the default json property names.
 */
export class EnrolledSessionsAdapter implements Adapter<EnrolledSessions> {
  EnrolledSessionDates;
  adapt(item: EnrolledSessionsInterface): EnrolledSessions {
    let enrolledSessions: EnrolledSessions;
    if (item) {
      enrolledSessions = new EnrolledSessions(
        item.id,
        item.name,
        item.date_begin,
        item.date_end,
        item.description, // Not currently being used
        item.other_info, // Not currently being used
        item.dates
      );
    }
    return enrolledSessions;
  }
}
